var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"programation-report-index\"\u003E\u003CdataTable :data=\"data\" :meta=\"meta\" @load-data=\"loadDdis\"\u003E\u003C\u002FdataTable\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;